export default `
query trackMyOrder($order_id: String!, $email: String!){
    trackMyOrder(order_id: $order_id, email: $email) {
          module_status {
              enabled
              message
          }
          order_id
          order_date
          tracking_hash
          status
          items {
              id
              product_image_url
              product_name
              product_sku
              product_price
              product_qty
              subtotal
              shipping_amount
              grand_total
          }
          shipping_address {
              name
              street
              city
              state
              postcode
              country
              telephone
          }
          shipping_method
          billing_address {
              name
              street
              city
              state
              postcode
              country
              telephone
          }
          payment_method
      }
  }
`;

